import { connect } from "react-redux";
import CreateFollowUp from "./createFollowUp";
import { bindActionCreators } from "redux";
import {
  getFollowUpDropDown,
  saveFollowUp,
} from "services/redux/sales/followUpForm/action";
import { documentUploadUrl } from "services/redux/fileUpload/action";
import { addPoc } from "services/redux/sales/poc/action";

const mapStateToProps = (state) => ({
  followUpDropDown: state.followUpFormReducer.followUpDropDown,
  followUpSuccess: state.followUpFormReducer.followUpSuccess,
  documentUrlData: state.fileUploadReducer.documentUrlData,
  pocDetails: state.pocReducer.pocDetails,
  pocById: state.pocReducer.pocById,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getFollowUpDropDown,
      saveFollowUp,
      documentUploadUrl,
      addPoc
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CreateFollowUp);
